/**
 * Quickstart Command
 * Scenario-based navigation guide for developers
 */
import { Command } from 'commander';
import chalk from 'chalk';
import { getCliName } from '../utils/cli-name.js';

/**
 * Create quickstart command - scenario-based navigation guide
 */
export function createQuickstartCommand(): Command {
    const cmd = new Command('quickstart')
        .description('Hướng dẫn nhanh theo từng tình huống phát triển')
        .action(() => {
            const name = getCliName();
            showQuickstart(name);
        });

    return cmd;
}

function showQuickstart(name: string): void {
    console.log(chalk.cyan.bold('\n🚀 Quickstart - Bắt đầu từ đâu?\n'));
    console.log(chalk.dim('Chọn tình huống phù hợp với bạn:\n'));

    // ── 1. First Time Setup ──
    console.log(chalk.bold('━━━ 🏁 MỚI BẮT ĐẦU ━━━'));
    console.log(`  ${chalk.cyan(`${name} doctor`)}                 Kiểm tra project đã setup đúng chưa`);
    console.log(`  ${chalk.cyan(`${name} guide`)}                  Xem toàn bộ hướng dẫn CLI commands`);
    console.log(`  ${chalk.cyan(`${name} t guide`)}                Hướng dẫn chi tiết task management`);
    console.log();

    // ── 2. Planning ──
    console.log(chalk.bold('━━━ 📋 LÊN KẾ HOẠCH ━━━'));
    console.log(`  ${chalk.cyan('/develop-feature')}              Phát triển tính năng mới (FRD → TDD → Code)`);
    console.log(`  ${chalk.cyan('/plan')}                         Lên kế hoạch nhanh → tạo tasks → implement`);
    console.log(`  ${chalk.cyan('/improve')}                      Phân tích & đề xuất cải thiện project`);
    console.log();

    // ── 3. Working with Tasks ──
    console.log(chalk.bold('━━━ ✅ LÀM VIỆC VỚI TASKS ━━━'));
    console.log(`  ${chalk.cyan('/pick-next-task')}               Resume hoặc bắt đầu task tiếp theo`);
    console.log(`  ${chalk.cyan('/review-tasks')}                 Review danh sách tasks, sắp xếp lại priority, dependency,...`);
    console.log(`  ${chalk.cyan(`${name} t ready`)}                Xem các tasks sẵn sàng để làm`);
    console.log(`  ${chalk.cyan(`${name} t summary`)}              Dashboard tổng quan tasks`);
    console.log();

    // ── 4. Code Quality ──
    console.log(chalk.bold('━━━ 🔍 CHẤT LƯỢNG CODE ━━━'));
    console.log(`  ${chalk.cyan('/review-local-changes')}         Review code thay đổi trước khi commit`);
    console.log(`  ${chalk.cyan('/commit-it')}                    Commit an toàn với message chi tiết`);
    console.log(`  ${chalk.cyan('/fix-bug')}                      Phân tích & sửa bug`);
    console.log();

    // ── 5. Documentation ──
    console.log(chalk.bold('━━━ 📝 TÀI LIỆU ━━━'));
    console.log(`  ${chalk.cyan('/gen-feature-doc')}              Tạo tài liệu cho 1 tính năng`);
    console.log(`  ${chalk.cyan('/gen-all-features-doc')}         Tạo tài liệu cho toàn bộ tính năng`);
    console.log(`  ${chalk.cyan('/gen-project-overview')}         Tạo tổng quan project`);
    console.log();

    // ── Typical Flow ──
    console.log(chalk.yellow.bold('━━━ 💡 FLOW PHÁT TRIỂN PHỔ BIẾN ━━━'));
    console.log(chalk.dim('  1. Kiểm tra setup         →  j doctor'));
    console.log(chalk.dim('  2. Lên kế hoạch           →  /develop-feature hoặc /plan'));
    console.log(chalk.dim('  3. Làm task               →  /pick-next-task'));
    console.log(chalk.dim('  4. Review & commit        →  /review-local-changes → /commit-it'));
    console.log(chalk.dim('  5. Kiểm tra tasks còn lại →  /review-tasks'));
    console.log();

    console.log(chalk.dim(`💡 Chạy "${name} guide" để xem đầy đủ danh sách commands.`));
    console.log();
}
